import { request } from '@/utils/request'
export function login(params) {
  return request({
    url: '/user/login',
    method: 'post',
    data: params
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

/* 获取验证码 */
// export function getAuthCode(params) {
//   return request({
//     url: `/sms-code/send/${params.phone}`,
//     method: 'get'
//   })
// }

export function getAuthCode({phone}) {
  return request({
    url: `/sms-code/sendSms`,
    method: 'post',
    phone
  })
}

/* 注册用户 */
export function registeredUser(params) {
  return request({
    url: '/user/registeredUser',
    method: 'post',
    data: params
  })
}

/**找回密码 */
export function regetPassword(params) {
  return request({
    url: '/user/resetPassword',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}
